<!-- @Description AI4Science -->
<template>
  <div class="product_digitization">
    <div class="info">
      <div class="title">AI4Science</div>
      <div class="content">
        华院计算依托认工业级智能体，在AI4Science 特别是在AI+新药研发、Al+合成生物、Al+医疗器械、Al+再生医学辅助、Al+大健康等5个领域进行创新发展，并取得了显著成绩。
      </div>
    </div>
    <div class="product">
      <div class="title">产品矩阵</div>
      <div class="product-catgory">
        <div class="product-catgory-item">
          <div class="product-catgory-item-title product-catgory-item-title2">
            AI+新药研发
          </div>
          <ProductMatrix />
        </div>
      </div>
      <div class="product-catgory">
        <div class="product-catgory-item">
          <div class="product-catgory-item-title product-catgory-item-title1">
            Al+合成生物
          </div>
          <ProductMatrix2 />
        </div>
      </div>
      <div class="product-catgory">
        <div class="product-catgory-item">
          <div class="product-catgory-item-title product-catgory-item-title2">
            Al+医疗器械
          </div>
          <ProductMatrix3 />
        </div>
      </div>
      <div class="product-catgory">
        <div class="product-catgory-item">
          <div class="product-catgory-item-title product-catgory-item-title1">
            Al+再生医学辅助
          </div>
          <ProductMatrix4 />
        </div>
      </div>
    </div>
    <div class="cases">
      <div class="title">客户案例</div>
      <Case :data.sync="case_list" class="case-list" />
    </div>
    <div class="visitingCard">
      <VisitingCard :data="visitlist" />
    </div>
  </div>
</template>
<script>
import Case from "@/components/customerCase.vue";
import VisitingCard from "@/components/visitingCard.vue";
import product_digitization_vx from "@/../static/img/product/product_digitization_vx.svg";
import business_digitization_vx from "@/../static/img/product/business_digitization_vx.png";
import ProductMatrix from "./productmatrix.vue";
import ProductMatrix2 from "./productmatrix2.vue";
import ProductMatrix3 from "./productmatrix3.vue";
import ProductMatrix4 from "./productmatrix4.vue";
export default {
  name: "product_digitization",
  components: {
    Case,
    VisitingCard,
    ProductMatrix,
    ProductMatrix2,
    ProductMatrix3,
    ProductMatrix4
  },
  data() {
    return {
      case_list: [
        {
          title: "抗老年痴呆/抗脑卒中小分子药物",
          img: "../../../static/img/product/case_yao.png",
          video:
            "",
          content: `基于华院的AI药物筛选平台，在小分子药物开发中成功筛选了抗老年痴呆(简称AD)和抗脑卒中的小分子化合物。`,
          isplay: false
        },
        {
          title: "食品安全方面的成功案例",
          img: "../../../static/img/product/case_hcsw.png",
          video:
            "",
          content: `包括两种降解真菌毒素的酶。呕吐毒素是污染广泛的真菌毒素，主要影响牲畜的健康，最终通过富集作用到达人体。我们通过合成生物酶改造引擎成功预测了DON降解酶的催化活性位点，并得到了生物学验证。玉米烯酮是一种主要存在于玉米中的具有生殖毒性的真菌毒素，我们通过合成生物酶改造引擎，成功优化了ZEN水解酶的耐酸性，使其在经历酸性环境后仍保持50%的活性。`,
          isplay: false
        },
        {
          title: "某三甲医院认知智能评估机",
          img: "../../../static/img/product/case_qx.png",
          video:
            "",
          content: `在某三甲医院部署的认知智能评估机实现了对认知状态的客观量化评估。设备内置MMSE、MoCA-B等标准量表，通过深度分析反应时、记忆力及决策特征，打破了传统人工评估的主观性限制。系统专注于阿尔茨海默症的早期筛查与长效监测，为神经科室提供高准确性、高重复性的辅助诊断方案及康复评估工具。`,
          isplay: false
        },
        {
          title: "新型细胞冷冻保存液",
          img: "../../../static/img/product/case_ld.png",
          video:
            "",
          content: `新型细胞冷冻保存液比肩美国优质产品，但成本大大下降，实现了冷冻保存液的自主研发和国产替代，现以酷护神为注册商标在GLP实验室小批量生产，提供多家单位使用，正在计划建立GMP车间实现大批量生产。`,
          isplay: false
        },

      ],
      visitlist: [
        // {
        //   department: "AI4Science部门联系人",
        //   name: "郭先生",
        //   vx: product_digitization_vx,
        //   mail: "haodang.guo@unidt.com"
        // },
        // {
        //   position: "数智人业务微信视频号",
        //   department: "",
        //   name: "",
        //   vx: business_digitization_vx
        // }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.product_digitization {
  width: 100%;
  padding: 96px 0px 0px;

  .info {
    width: 100%;
    height: 632px;
    background: url("../../../../static/img/product/product_digitization_bg.png")
      no-repeat 0 0 / 100%;
    overflow: hidden;

    .title {
      margin-top: 48px;
      font-size: 44px;
      font-weight: 500;
      color: #08204d;
      line-height: 60px;
      text-align: center;
    }

    .content {
      padding: 0 68px;
      font-size: 24px;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      margin-top: 24px;
    }
  }

  .product {
    .title {
      font-size: 40px;
      color: #08204d;
      line-height: 56px;
      text-align: center;
      margin-top: 44px;
    }

    .product-catgory {
      .product-catgory-item {
        .product-catgory-item-title {
          width: 100%;
          height: 200px;
          line-height: 200px;
          font-size: 32px;
          color: #08204d;
          text-align: center;
        }

        .product-catgory-item-title1 {
          background: url("../../../../static/img/product/product_society_arithmetic_bg1.png")
            no-repeat left center / 100%;
        }

        .product-catgory-item-title2 {
          background: url("../../../../static/img/product/product_society_arithmetic_bg2.png")
            no-repeat left center / 100%;
        }
      }
    }
  }

  .cases {
    .title {
      margin-top: 44px;
      font-size: 40px;
      font-weight: 500;
      color: #08204d;
      line-height: 56px;
      text-align: center;
    }

    .case-list {
      width: calc(100% - 110px);
      margin: 24px 55px;
    }
  }

  .visitingCard {
    width: calc(100% - 128px);
    padding: 40px 64px;
    background: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/digitization/index.vue